import axios from "utils/axios";

// Constant
import { API } from "constants/index";

// Types
import {
    FunctionHierarchy,
    ProjectCreationResponse,
    ProjectSearchAICreationResponse,
    ProjectsListResponse,
    TNewProjectPayload,
    TProjectsPayloadMeta,
} from "./project.types";
import { AxiosResponse } from "axios";
import { buildParamsString } from "utils";

export type ProjectRequestOptions = {
    exclude_clones?: boolean;
    exclude_activity_logs?: boolean;
    exclude_company_set_companies?: boolean;
    exclude_person_set_persons?: boolean;
    include_required_children?: boolean;
    include_avatars?: boolean;
    include_brief_counts?: boolean;
};

export const getProjectsService = (params: TProjectsPayloadMeta): Promise<AxiosResponse<ProjectsListResponse>> => {
    const path = params.project_name
        ? `page_size=${params.page_size}&page_no=${params.page_no}&project_name=${params.project_name}&only_user_org_selected=${params.useSelectedOrg}`
        : `page_size=${params.page_size}&page_no=${params.page_no}&only_user_org_selected=${params.useSelectedOrg}`;
    return axios.get(`${API.PROJECT.SEARCH}?${path}`);
};

export const createProjectService = (params: TNewProjectPayload): Promise<AxiosResponse<ProjectCreationResponse>> => {
    const { group_id, ...restParams } = params;
    return axios.post(`${API.PROJECT.GET}/create/${group_id}`, restParams);
};

export const fetchProjectByIdService = <T>(
    id: number,
    project_path?: string,
    options?: {
        exclude_clones?: boolean;
        exclude_activity_logs?: boolean;
        exclude_company_set_companies?: boolean;
        exclude_person_set_persons?: boolean;
        include_required_children?: boolean;
        include_avatars?: boolean;
        include_brief_counts?: boolean;
    }
): Promise<AxiosResponse<T>> => {
    const path = project_path ? `project_path=${project_path}` : "";
    const newOptions = {
        exclude_clones: true,
        exclude_activity_logs: true,
        exclude_company_set_companies: true,
        exclude_person_set_persons: true,
        include_required_children: true,
        include_avatars: false,
        include_brief_counts: false,
        ...options,
    };
    const queryParams = buildParamsString(newOptions);
    return axios.get(
        path ? `${API.PROJECT.GET}/${id}?${path}&${queryParams}` : `${API.PROJECT.GET}/${id}?${queryParams}`
    );
};

export const updateProjectByPathService = ({
    id,
    project_path,
    data,
    echo = false,
}: {
    id: number;
    project_path: string;
    data: any;
    echo?: boolean;
}): Promise<AxiosResponse<any>> =>
    axios.patch(`${API.PROJECT.GET}/${id}?project_path=${project_path}&echo=${echo}`, data);

export const saveProjectByPathService = ({
    id,
    project_path,
    data,
    echo = false,
}: {
    id: number;
    project_path: string;
    data: any;
    echo?: boolean;
}): Promise<AxiosResponse<any>> => {
    return axios.post(`${API.PROJECT.GET}/${id}?project_path=${project_path}&echo=${echo}`, data);
};
export const createSearchAIService = ({
    id,
    data,
}: {
    id: number;
    data: {
        search_ai_name: string;
        peers_company_set_path: string;
        company_set_copy_name: string;
    };
}): Promise<AxiosResponse<ProjectSearchAICreationResponse>> => {
    return axios.post(`${API.PROJECT.GET}/${id}/create_search_ai?echo=true`, data);
};

export const fetchFunctionsAndLevels = (): Promise<AxiosResponse<FunctionHierarchy>> =>
    axios.get(API.PROJECT.FUNCTIONS_LEVELS);
